// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['id_ID']  = {
  "name": "id_ID",
  "day": {
    "abbrev": [
      "Min",
      "Sen",
      "Sel",
      "Rab",
      "Kam",
      "Jum",
      "Sab"
    ],
    "full": [
      "Minggu",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu"
    ]
  },
  "month": {
    "abbrev": [
      "Jan",
      "Peb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des"
    ],
    "full": [
      "Januari",
      "Pebruari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d/%m/%y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %r %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

